export default "__VITE_ASSET__DrfPp0vS__"